export default __webpack_public_path__ + "static/media/coach-and-mentor-side-banner.ccf462d6.webp";